const StarIconPoints = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width="26"
    height="26"
    fill="#4d1010"
    stroke="#4d1010"
    version="1.1"
    viewBox="0 0 512 512"
    {...props}
  >
    <g id="SVGRepo_iconCarrier">
      <path d="m295.578 214.41-39.328-80.258-39.766 80.039L128 226.785l63.812 62.578-15.343 88.032 79.219-41.375 79 41.828-14.86-88.125L384 227.52z"></path>
      <path d="M256 0C114.609 0 0 114.609 0 256s114.609 256 256 256 256-114.609 256-256S397.391 0 256 0zm0 472c-119.297 0-216-96.703-216-216S136.703 40 256 40s216 96.703 216 216-96.703 216-216 216z"></path>
    </g>
  </svg>
);

export default StarIconPoints;
